import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast } from 'services/toasterService';

export default function useCopyFilesAndFolder(setMessage) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.REPOSITORY_COPY_AND_MOVE_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data?.message });
        // cb();
        queryClient.invalidateQueries('repository-folders-sub-folder');
        queryClient.invalidateQueries('repository-folders');
      },
      onError: (error) => {
        // ErrorToast({ text: error.response.data.message });
        setMessage(error.response.data.message);
      },
    }
  );
}
